<template>
  <div>
    <div class="tabs">
      <ul>
        <router-link to="/stats/profit" tag="li" active-class="is-active">
          <a>{{"stats.tabs.profit" | translate}}</a>
        </router-link>
        <router-link to="/stats/games" tag="li" active-class="is-active">
          <a>{{"stats.tabs.games" | translate}}</a>
        </router-link>
      </ul>
    </div>

    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'stats'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/stats/index.vue